import { gql } from '@apollo/client';

export const RECORDINGS = gql`
  query recordings($filters: RecordingsFilterInput) {
    recordings(filters: $filters) {
      count
      data {
        id
        title
        status
        durationSeconds
        createdAt
        project {
          id
          name
        }
      }
    }
  }
`;

export const MEETSENSE_WORKSPACES = gql`
  query MeetsenseWorkspaces($filters: MeetsenseWorkspacesFilterInput) {
    meetsenseWorkspaces(filters: $filters) {
      count
      data {
        id
        name
        isDefault
        createdBy {
          id
          name
          email
        }
        projects {
          id
          name
          type
          description
          createdAt
        }
      }
    }
  }
`;

export const RECORDING_DETAIL = gql`
  query recording($id: ID!, $workspaceId: ID!) {
    recording(id: $id, workspaceId: $workspaceId) {
      recording {
        id
        title
        status
        durationSeconds
        createdAt
        errorMessage
        project {
          id
          name
        }
      }
      contextName
      audioUrl
      languageCode
      transcript
      debrief {
        summary
        decisions
        ghostedTopics {
          topic
          note
        }
        momMarkdown
        createdAt
      }
      actionItems {
        id
        task
        owner
        deadline
        priority
        completed
      }
    }
  }
`;
